module.exports = __webpack_public_path__ + "vue-assets/img/digital_plan.611691c0.png";